import { IReportSection } from '@modeso/aumico-lib-annualreport-fe';

export interface IReportOrderResult {
    reportSections: IReportSection[];
    reportsOrder: string[];
}
